import React from 'react'
import { arrayOf, string, number } from 'prop-types'

import SectionContainer from 'components/atoms/SectionContainer'
import Container from 'components/atoms/Container'
import Typography from 'components/atoms/Typography'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import SectionTitle from 'components/atoms/SectionTitle'

const SimpleListSection = ({ id, title, list, backgroundUrl, marginTop, marginBottom }) => {
  const listMod3 = list.length % 3
  const listPerSection = Math.floor(list.length / 3)

  return (
    <div className="simple-list-section" id={id}>
      <SectionContainer
        className="simple-list-section__section"
        paddingTop={80}
        paddingBottom={120}
        marginTop={marginTop}
        marginBottom={marginBottom}
        backgroundColor="#1c80e7"
      >
        <Container>
          <SectionTitle title={title} color="#fff" />
          <Row>
            <Col md="4">
              {
                list.slice(0, listPerSection + (listMod3 > 0 ? 1 : 0))
                  .map((listItem, idx) => (
                    <Typography
                      className="simple-list-section__item"
                      component="p"
                      variant="headline"
                      key={`fcli1-${idx}`}
                    >
                      {listItem}
                    </Typography>
                  ))
              }
            </Col>
            <Col md="4">
              {
                list.slice((
                  listPerSection + (listMod3 > 0 ? 1 : 0)
                ), 2 * (listPerSection) + listMod3)
                  .map((listItem, idx) => (
                    <Typography
                      className="simple-list-section__item"
                      component="p"
                      variant="headline"
                      key={`fcli2-${idx}`}
                    >
                      {listItem}
                    </Typography>
                  ))
              }
            </Col>
            <Col md="4">
              {
                list.slice((
                  2 * (listPerSection) + listMod3
                ), list.length)
                  .map((listItem, idx) => (
                    <Typography
                      className="simple-list-section__item"
                      component="p"
                      variant="headline"
                      key={`fcli3-${idx}`}
                    >
                      {listItem}
                    </Typography>
                  ))
              }
            </Col>
          </Row>
        </Container>
      </SectionContainer>
      <style jsx>
        {`
          .simple-list-section {
            :global(&__section) {
              min-height: 474px;
              background-color: #1c80e7;
              @media screen and (min-width: 768px) {
                background-image: url('${backgroundUrl}');
                background-size: cover;
                background-position: center right;
                background-repeat: no-repeat;
              }
            }
            :global(&__title, &__item) {
              color: #fff !important;
            }
            :global(&__item) {
              margin-bottom: .5em !important;
            }
          }
        `}
      </style>
    </div>
  )
}

SimpleListSection.propTypes = {
  list: arrayOf(string),
  title: string,
  backgroundUrl: string,
  id: string,
  marginTop: number,
  marginBottom: number,
}

export default SimpleListSection
